import type { SVGProps } from "react";

export function EggIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="#F3AD61"
        d="M16.331 2c-2.57 0-4.98 1.28-6.42 3.4l-.13.19A21.92 21.92 0 0 0 6.101 20l.08.8c.5 5.21 4.88 9.18 10.11 9.18c5.25 0 9.63-3.99 10.11-9.22l.09-.93a21.9 21.9 0 0 0-3.78-14.48A7.77 7.77 0 0 0 16.331 2"
      />
    </svg>
  );
}

export function BreadIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      aria-hidden="true"
      {...props}
    >
      <g fill="none">
        <path
          fill="#F3AD61"
          d="M27.34 25.593L15 30V16.5L29 13v10.238a2.5 2.5 0 0 1-1.66 2.355"
        />
        <path
          fill="#E19747"
          d="M14.59 3.262L3.202 7.556L17 19l10.98-3.8A3 3 0 0 0 30 12.364v-.904a5 5 0 0 0-3.239-4.679l-9.35-3.52a4 4 0 0 0-2.821 0"
        />
        <path
          fill="#FFDEA7"
          d="M3 13.5v9.955a3 3 0 0 0 1.903 2.793l9.366 3.679A2 2 0 0 0 17 28.065V19l.157-.235a5.02 5.02 0 0 0-2.415-7.487L4.702 7.513A2 2 0 0 0 2 9.386v1.403a4 4 0 0 0 .672 2.219z"
        />
        <path
          fill="#E19747"
          d="M8 13.5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0m-2 1a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0M7.5 17a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m-1.5.5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0M9.5 16a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m2.5-1.5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0m1.5 3.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m-1.5.5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0M9.5 20a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m-1.5.5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0M5.5 22a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m4.5 1.5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0m1.5-.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1m2.5-1.5a.5.5 0 1 1-1 0a.5.5 0 0 1 1 0m-.5 3.5a.5.5 0 1 0 0-1a.5.5 0 0 0 0 1"
        />
      </g>
    </svg>
  );
}

export function TomatoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      aria-hidden="true"
      {...props}
    >
      <g fill="none">
        <path
          fill="#008463"
          d="M15.99 5a1 1 0 0 1 1 1v4.42a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1"
        />
        <path
          fill="#F8312F"
          d="M19.97 9.99H12c-5.53 0-10 4.48-10 10c0 5.53 4.48 10 10 10h7.96c5.53 0 10-4.48 10-10c.01-5.52-4.47-10-9.99-10"
        />
        <path
          fill="#00D26A"
          d="M15.4 12.66H9.64c-3.13 0-5.66-2.53-5.66-5.66h5.76c3.13 0 5.66 2.53 5.66 5.66M27.97 7h-5.76c-3.13 0-5.66 2.53-5.66 5.66h5.76c3.13 0 5.66-2.53 5.66-5.66"
        />
        <path
          fill="#00F397"
          d="M5.75 15.07h5.77a5.65 5.65 0 0 0 4.468-2.187a5.65 5.65 0 0 0 4.472 2.187h5.76c0-3.12-2.54-5.66-5.66-5.66h-9.15c-3.13 0-5.66 2.53-5.66 5.66"
        />
      </g>
    </svg>
  );
}

export function AvocadoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      aria-hidden="true"
      {...props}
    >
      <g fill="none">
        <path
          fill="#44911B"
          d="M25.58 20.33c.16-1.89-.33-3.72 1.01-5.06l.83-.83a6.06 6.06 0 0 0 0-8.56l-1.86-1.86l-1.34 1.34c-1.49.04-2.97.63-4.11 1.77l-.21.2a8.02 8.02 0 0 1-4.99 2.32c-2.5.21-4.84 1.3-6.62 3.08a10.43 10.43 0 0 0-2.42 10.98l-.68.68l2.55 2.55a10.44 10.44 0 0 0 14.77 0c1.77-1.77 2.86-4.11 3.07-6.61"
        />
        <path
          fill="#008463"
          d="M20.66 2c-1.84 0-3.58.72-4.88 2.02l-.18.19c-.95.95-2.22 1.54-3.57 1.66c-2.59.22-5.02 1.35-6.85 3.18A10.8 10.8 0 0 0 2 16.72c0 2.9 1.13 5.62 3.18 7.67s4.77 3.18 7.67 3.18s5.62-1.13 7.67-3.18c1.83-1.83 2.97-4.27 3.19-6.85a5.7 5.7 0 0 1 1.66-3.57l.19-.19a6.87 6.87 0 0 0 2.02-4.88c0-1.84-.72-3.58-2.02-4.88A6.93 6.93 0 0 0 20.66 2"
        />
        <path
          fill="#C3EF3C"
          d="m24.32 12.93l.19-.19a5.43 5.43 0 0 0 0-7.68a5.43 5.43 0 0 0-7.68 0l-.19.19a7.18 7.18 0 0 1-4.48 2.08a9.53 9.53 0 0 0-5.94 2.76a9.367 9.367 0 0 0 0 13.25a9.367 9.367 0 0 0 13.25 0a9.53 9.53 0 0 0 2.76-5.94c.15-1.68.89-3.27 2.09-4.47"
        />
        <path
          fill="#6D4534"
          d="M13.29 20.69a4.36 4.36 0 1 0 0-8.72a4.36 4.36 0 0 0 0 8.72"
        />
      </g>
    </svg>
  );
}

export function JarIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      aria-hidden="true"
      {...props}
    >
      <g fill="none">
        <path fill="#9B9B9B" d="m22 5l-6-1.141L10 5v1l6 1.394L22 6z" />
        <path
          fill="#AEDDFF"
          d="M7.895 6C6.296 6 5 7.226 5 8.738v18.524C5 28.774 6.296 30 7.895 30h16.21C25.704 30 27 28.774 27 27.262V8.738C27 7.226 25.704 6 24.105 6z"
        />
        <path
          fill="#BEBEBE"
          d="M8 3.5A1.5 1.5 0 0 1 9.5 2h13a1.5 1.5 0 0 1 0 3h-13A1.5 1.5 0 0 1 8 3.5"
        />
        <rect width="2" height="20" x="22" y="8" fill="#fff" rx="1" />
        <path
          fill="#9B9B9B"
          d="M9.999 14A1 1 0 0 0 9 15v5a1 1 0 0 0 .999 1H22a1 1 0 0 0 1-1v-5a1 1 0 0 0-.999-1z"
        />
      </g>
    </svg>
  );
}
